import { call, put, takeLatest } from 'redux-saga/effects';
import { APPLY_PROVIDER_EXPERIENCE_FILTER } from '../actions/actionTypes';
import { applyProviderExperienceFilterSuccess } from '../actions/providerExperience/provider-experience-filters-action';

export function* applyProviderExperienceFilter(action: any) {
  try{
    yield put(applyProviderExperienceFilterSuccess(action.payload));
  } catch (error) {
    console.error(error)
  }
}

export function* providerExperienceFiltersSaga() {
  yield takeLatest(APPLY_PROVIDER_EXPERIENCE_FILTER, applyProviderExperienceFilter);
}

export default [providerExperienceFiltersSaga]